import { App } from "vue";
import MultilingualServiceClass from "../../../libs/application/multilingual-service.js";

const MultilingualService = new MultilingualServiceClass();

export default {
	install: function (app: App) {
		app.config.globalProperties.$t = (
			string: string,
			args: Record<string, any> | undefined = undefined
		): string => {
			return (MultilingualService as any).translate(string, args);
		};

		app.config.globalProperties.$tc = (
			string: string,
			number: number
		): string => {
			return MultilingualService.translate_plural(string, number);
		};

		app.config.globalProperties.$te = (string: string): boolean => {
			return MultilingualService.translate(string) != null;
		};
	}
};

declare module "@vue/runtime-core" {
	interface ComponentCustomProperties {
		$t: (string: string, args?: Record<string, any> | undefined) => string;
		$tc: (string: string, number: number) => string;
		$te: (string: string) => boolean;
	}
}
